module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pullsheet-view"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n      Loading...\n    ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.PullSheet) ? _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "grid-options"
  }, [_c('label', [_vm._v("Thumbnail Size")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-switch",
    class: {
      switched: _vm.fullsizeview
    },
    on: {
      "click": _vm.toggleViewSize
    }
  }, [_c('div', {
    staticClass: "option",
    class: {
      highlighted: !_vm.fullsizeview
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_module")]), _c('span', [_vm._v(" Grid")])]), _vm._v(" "), _c('div', {
    staticClass: "option",
    class: {
      highlighted: _vm.fullsizeview
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_stream")]), _c('span', [_vm._v(" Full")])]), _vm._v(" "), _c('div', {
    staticClass: "highlight"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "print-header"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n            Pullsheet - " + _vm._s(_vm.PullSheet.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("213.305.0464")]), _vm._v(" "), _c('h4', [_c('A', {
    attrs: {
      "href": "mailto:renee@therenees.com"
    }
  }, [_vm._v("renee@therenees.com")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('h1', [_vm._v("Pullsheet")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.PullSheet.name))])]), _vm._v(" "), _c('div', {
    staticClass: "pullsheetphotos"
  }, [_c('div', {
    staticClass: "pl-listing",
    class: {
      grid: !_vm.fullsizeview, full: _vm.fullsizeview
    }
  }, [_vm._l((_vm.pullSheetPLs), function(PL) {
    return [_c('PLThumb', {
      key: PL.plno,
      attrs: {
        "PL": PL,
        "fullsizeview": _vm.fullsizeview,
        "tagids": [],
        "photofilter": "default",
        "showpullsheet": false,
        "lazy": false
      }
    }), _vm._v(_vm._s(' ') + "\n        ")]
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  })], 2)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1204dcec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PullSheetView.vue
// module id = 199
// module chunks = 1